module.exports = __webpack_public_path__ + "static/media/tricka.9d92d5a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/exhibitors/tricka.jpg
// module id = 461
// module chunks = 0